<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
        
          <!-- <div slot="header">Tree Cut Reportings</div> -->
          <template slot="header">
            <b-row>
              <b-col cols="12" md="2" class="py-2">
                <span><b>Cases</b></span>
              </b-col>
          
            </b-row>
             <b-row class="text-left" align-v="center">       
              <b-col cols="12" md="3">
                <span style="font-size: 12px">Please Select From Date:</span
                ><br />
                <b-form-input
                  class="pt-1"
                  v-model="from"
                  type="date"
                  id="date"
                ></b-form-input>
              </b-col>

              <b-col cols="12" md="3">
                <span style="font-size: 12px">Please Select To Date:</span><br />
                <b-form-input
                  class=""
                  v-model="to"
                  type="date"
                  id="date"
                ></b-form-input>
              </b-col>
               <b-col cols="12" md="2" class="pt-3">
               <b-dropdown variant="outline-primary" size="sm" id="dropdown-1" :text="chartName">
              <b-dropdown-item
                v-for="(item,i) in chartTypes"
                :key="i"
                @click="updateChart(item)"
              >{{item.name}}</b-dropdown-item>
            </b-dropdown>
             </b-col>
              <b-col cols="12" md="4" class="pt-3">
                <b-form @submit.prevent="getSearch" class="pr-4">
                  <b-row>
                    <b-col cols="7">
                      <b-form-input
                        list="searchData"
                        v-model="searchKey"
                        placeholder="Search"
                        size="md"
                      ></b-form-input>
                      <!-- <datalist id="searchData">
                        <option v-for="(item,i) in searchData" :key="i">{{item.keyword}}</option>
                      </datalist> -->
                    </b-col>
                    <b-col cols="3"  align="right" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="getSearch"
                        >Search</b-button
                      >
                    </b-col>
                    <b-col cols="1"  align="left" class="pt-1" >
                      <b-button
                        variant="outline-primary"
                        class="px-2"
                       
                        size="sm"
                        @click="getData()"
                        >All</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="false"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="incidents"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @row-clicked="rowClicked"
          >
             <template slot="HEAD_totalcount" >
                <span><i class="fa fa-square fa-2x " Style="color:#cccccc" aria-hidden="true"></i></span>
              </template>
             <template slot="HEAD_beencut" >
                <span><i class="fa fa-square fa-2x " Style="color:#E25151" aria-hidden="true"></i></span>
              </template>
              <template slot="HEAD_mightbecut">
                <span ><i class="fa fa-square fa-2x " Style="color:#FC9941" aria-hidden="true"></i></span>
              </template>
              <template slot="HEAD_havebeencut">
                <span><i class="fa fa-square fa-2x " Style="color:#6E6E6E" aria-hidden="true"></i></span>
              </template>
              <template >
              <!-- <div class="text-center">
                <span >{{getSum(data.item)}}</span>
               
              </div> -->
              <div>
      Sorting By: <b>{{ sortBy }}</b>, Sort Direction:
      <b>{{ sortDesc ? 'Descending' : 'Ascending' }}</b>
    </div>
            </template>
           
            <template slot="caseid" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.caseidentifier">{{
                  data.item.caseidentifier
                }}</span>
                <span v-else>{{ data.item.caseid }}</span>
              </div>
            </template>
            <template slot="createddate" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.createddate">{{
                  formatDate(data.item.createddate)
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            
            <template v-slot:cell(isanonymous)="data">
              <!-- <span v-if="data.item.isanonymous">{{data.item.isanonymous}}</span>
              <span v-else>-</span>-->
              <div class="text-center">
                <span v-if="data.item.isanonymous">Yes</span>
                <span v-else>No</span>
              </div>
            </template>
            <template v-slot:cell(locationname)="data">
              <div class="text-left">
                <span v-if="data.item.locationname">{{
                  data.item.locationname
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            
            <template slot="addedby" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.addedby.name">{{
                  data.item.addedby.name
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="Pictures" slot-scope="data">
              <div class="text-center">
                <span v-if="data.item.photos">{{
                  data.item.photos.length
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="Watchers" slot-scope="data">
              <div class="text-center">
                <span v-if="data.item.watchcount">{{
                  data.item.watchcount
                }}</span>
                <span v-else>0</span>
              </div>
            </template>
            <template slot="Comments" slot-scope="data">
              <div class="text-center">
                <span v-if="data.item.commentcount">{{
                  data.item.commentcount
                }}</span>
                <span v-else>0</span>
              </div>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalIncidents"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
            
            />
          </nav>
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data: () => {
    return {
      incidents: [],
      idset:[],
      from:null,
      to:null,
      sortBy: 'total',
      sortDesc: false,
      fields: [
        { key: "caseid", label: "Case ID", sortable: true,class: 'text-left' },
        { key: "createddate", label: "Posted On", sortable: true },
        { key: "totalcount", label: "Total", sortable: true,class: 'text-center' },
        { key: "beencut", label: "Being Cut", sortable: true,class: 'text-center' },
        { key: "mightbecut", label: "Might be cut", sortable: true, class: 'text-center' },
        { key: "havebeencut", label: "Have Been Cut", sortable: true,class: 'text-center' },
        
        {
          key: "locationname",
          label: "Location",
          sortable: true,
          align: "center",
          tdClass:"tdwidth"
        },
        { key: "Pictures", label: "Pictures", sortable: true,class: 'text-left' },
        { key: "Watchers", label: "Watchers", sortable: true,class: 'text-left' },
        { key: "Comments", label: "Comments", sortable: true,class: 'text-left' },
        { key: "addedby", label: "Posted By", sortable: true },
      ],
      chartName: "Filter",
      chartType: null,
      chartTypes: [
       
        { name: "Last 90 Days", value: 90 },
        { name: "Last 60 Days", value: 60 },
        { name: "Last 30 Days", value: 30 },
        { name: "Last 15 Days", value: 15 }
      ],
      searchData:[],
      searchKey:null,
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      totalIncidents: 0,
    };
  },
  beforeMount() {
    this.getData();
    // this.getlastsearches();
  },
  watch:{
// searchKey(){
//   this.getSearch()
// }
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getData();
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    // getSum(item){
    //   var sum = item.beencut + item.havebeencut + item.mightbecut;
    //   return  sum;
    // },
    updateChart(item) {
      this.chartName = item.name;
      this.chartType = item.value;
      this.getSearch();

    },
    getData() {
      this.chartName = "Filter";
      this.chartType = null;
      this.appLoading = true;
      axios({
        url: "/search/incident",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   count: this.perPage,
        //   page: this.currentPage,
        // },
      })
        .then((response) => {
          this.incidents = response.data.data;
          for(var i=0;i<this.incidents.length;i++)
          { 
            this.idset[i]=this.incidents[i]._id
          }
          this.totalIncidents = response.data.count;
          this.searchKey=null
          this.appLoading = false;
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    // getlastsearches() {
    //   this.appLoading = true;
    //   axios({
    //     url: "/incident/lastsearches",
    //     method: "GET",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     params: {
    //       count: this.perPage,
    //       page: this.currentPage,
    //     },
    //   })
    //     .then((response) => {
    //       this.searchData = response.data.data;
    //       this.totalIncidents = response.data.totalcount;
    //       this.appLoading = false;
    //     })
    //     .catch((e) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //     });
    // },
    getSearch() {
      this.appLoading = true;
      if( (this.from || this.to || this.searchKey)){
      axios({
        method: "GET",
        url: "/search/incident",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.perPage,
          page: this.currentPage,
          keyword: this.searchKey,
          from:this.from,
          to:this.to,
            
          
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.incidents = response.data.data;
          for(var i=0;i<this.incidents.length;i++)
          { 
        
            this.idset[i]=this.incidents[i]._id
          }
          this.totalIncidents = response.data.count;
        })
        .catch((err) => {
          this.ServerError = true;
        });
      }else if(this.chartType != null){
        
        this.to = null;
        this.from = null;
        axios({
        method: "GET",
        url: "/search/incident",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // count: this.perPage,
          // page: this.currentPage,
           keyword: this.searchKey,
           from:this.from,
           to:this.to,
           filter:this.chartType,
          
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.incidents = response.data.data;
          for(var i=0;i<this.incidents.length;i++)
          { 
        
            this.idset[i]=this.incidents[i]._id
          }
          this.totalIncidents = response.data.count;
        })
        .catch((err) => {
          this.ServerError = true;
        });
      }
      
    },
    rowClicked(item) {
      this.$router.push("/Cases/" + item._id+"/" +this.idset);
      // this.$router.push("/Cases/" + item._id+"/" +this.idset);
    },
  },
};
</script>

<style>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.tdwidth{
  width:20%!important;
}
</style>
